import { Component, OnInit, Injector } from '@angular/core';
import { SettingsService } from '../../../core/settings/settings.service';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-recuperar-senha',
    templateUrl: './recuperar-senha.component.html',
    styleUrls: ['./recuperar-senha.component.scss'],
    standalone: false
})

export class RecuperarSenhaComponent implements OnInit {

  router: Router;
  errorMessage = '';
  public fase = 'check';
  public celular = '';
  formResgate: any;

  constructor(
    injector: Injector,
    public settings: SettingsService,
    private http: HttpClient
  ) {
    this.router = injector.get(Router);
  }

  ngOnInit() {

    this.formResgate = {
      cpf: ''
    };

  }

  resgatarSenha() {

    try {

      // console.log('>>>>>>>>>> Preparando resgatar senha...');
      // console.log('>>>>>>>>>> formResgate: ' + JSON.stringify(this.formResgate));
      // console.log(this.formResgate.cpf.length);

      if (this.formResgate.cpf === '' || this.formResgate.cpf.length !== 11) {
        this.formResgate.cpf = '';
        return this.errorMessage = 'CPF inválido! Verifique o número digitado.';
      }

      const config = {
        headers: {
          'x-token': this.settings.configUso.X_TOKEN_API
        }
      };

      const url = this.settings.configUso.urlApiPadrao + 'proxy/hotsite/v1/usuario/resgatarsenha';

      this.http.post(url, this.formResgate, config)
        .subscribe(data => {
          // console.log('>>>>>>>>>> Retorno resgate de senha: ' + JSON.stringify(data));

          if (data['status'] === 200) {
            // console.log('>>>>> Resgate efetuado com sucesso!');
            this.celular = data['celular'];
            this.fase = 'sucesso';

          } else {
            this.formResgate.cpf = '';
            const message = data['message'];
            return this.errorMessage = message;
          }

        });

    } catch (err) {

      return this.errorMessage = 'Erro ao resgatar senha.';

    }

  }

  goLogin() {

    this.router.navigate(['/login']);

  }

}
